export function get(name: string) {
  const val = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return val ? val[2] : null;
}
